import { render, staticRenderFns } from "./ConfigurarNotificacion.vue?vue&type=template&id=066d5390&scoped=true&"
import script from "./ConfigurarNotificacion.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarNotificacion.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarNotificacion.vue?vue&type=style&index=0&id=066d5390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d5390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('066d5390', component.options)
    } else {
      api.reload('066d5390', component.options)
    }
    module.hot.accept("./ConfigurarNotificacion.vue?vue&type=template&id=066d5390&scoped=true&", function () {
      api.rerender('066d5390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/PlanesMantenimiento/ConfigurarNotificacion.vue"
export default component.exports